const toUppercasedBooleanString = (value): any => {
  return Boolean(value).toString().toUpperCase()
}

export default toUppercasedBooleanString
